import { Container, Grid, Typography } from "@mui/material";
import useIsMobileView from "../utils/hooks/useIsMobileView";
import VButton from "./Common/VButton";

const Home = () => {
  const IsMobileView = useIsMobileView();

  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: IsMobileView ? "column-reverse" : "column",
      }}
    >
      <Container sx={styles.gridContainer}>
        <Grid container>
          <Grid item xs={12} md={9} lg={9}>
            <Container disableGutters sx={styles.textContainer}>
              <Typography variant="h5" align="left" sx={styles.title}>
                Tere tulemast!
              </Typography>
              <Typography paragraph>
                Düsartrilise kõne arusaadavuse test (DÜKA test) lubab hinnata, kuivõrd on inimese kõne kuulajale
                arusaadav. Düsartria tõttu muutub inimese kõne kuulajale kas vähem arusaadavaks või mõnikord isegi
                täiesti arusaamatuks. Kuulajale arusaamatu kõne mõjutab negatiivselt düsartriaga inimese elukvaliteeti.
                Siin tuleb appi logopeediline teraapia, mille käigus düsartriaga inimene sooritab teatud perioodi
                jooksul harjutusi kõne arusaadavuse parandamiseks. Teraapia tulemuslikkuse hindamiseks peab nii teraapia
                alguses kui ka käigus kõne kvaliteeti mõõtma. Selline dünaamiline hindamine on kasulik nii logopeedile
                kui patsiendile, sest teeb töö tulemused nähtavamaks.
              </Typography>
              <Typography paragraph>
                DÜKA testi raames hinnatakse täiskasvanud patsiendi kõne arusaadavust üksiksõna tasandil. Selline
                lahendus sobib eeskätt mõõduka või raske düsartriaga inimeste kõne hindamiseks. Kerge düsartria puhul
                võib kõne arusaadavus sõna tasandil olla hea, kuid lausungi või pikema ütluse tasemel rohkem häiritud.
                Siiski tasub DÜKA testi alusel hinnata düsartrilise kõne arusaadavust kõikide raskusastmete puhul.
              </Typography>
            </Container>
          </Grid>
          <Grid container item xs={12} md={3} lg={3} direction="column" justifyContent="space-evenly" spacing={2}>
            <Grid item>
              <VButton text="Rohkem infot" type="outlined" navigate="/rohkeminfot" />
            </Grid>
            <Grid item>
              <VButton text="Korduma Kippuvad Küsimused" type="outlined" navigate="/kkk" />
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Grid container sx={[IsMobileView ? { marginBottom: "1em" } : { marginTop: "1em" }]} columnSpacing={4}>
        <Grid item xs>
          <VButton text="Proovitest" type="outlined" navigate="/proovitest" />
        </Grid>
        <Grid item xs>
          <VButton text="TEST" navigate="/testialgus" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;

const styles = {
  title: {
    fontWeight: "700",
    pb: "5%",
  },
  gridContainer: {
    backgroundColor: "white",
    borderRadius: "20px",
    px: "5%",
    py: "5%",
  },
  textContainer: {
    px: "2%",
  },
};
